import styled from 'styled-components';

export const CampaignPlanFormStyled = styled.div`
.campaignPlanModal {
  display: flex;
  flex-direction: column;
  gap: 16px;

  &__row {
    display: flex;
    gap: 16px;

    &Country, &Category {
      flex: 1;
    }
  }
}
`;
